import { environment } from '../../../environments/environment.local';

export const voyageUriTemplate = (voyageId?: string): string => {
  return `${environment.API.VOYAGES_URI}/${voyageId}`;
};
